import type { Cache } from 'swr';

import { StorageClient } from '@atlaskit/frontend-utilities/storage-client';

const STORAGE_KEY = 'POST_OFFICE__CLIENT_CACHE';
const CACHE_KEY = 'placement-api-cache';
const CACHE_EXPIRY = 120000; // 2 minutes

const storageClient = new StorageClient(STORAGE_KEY);

export const writeCacheToLocalStorage = (cache: Cache) => {
	const appCacheKeys = Array.from(cache.keys());
	if (appCacheKeys.length > 0) {
		const appCache = appCacheKeys.map((key) => [key, cache.get(key)]);
		storageClient.setItemWithExpiry(CACHE_KEY, appCache, CACHE_EXPIRY);
	}
};

export const localStorageCacheProvider = () => {
	if (typeof window === 'undefined') {
		// Return a dummy storage for server-side rendering
		return new Map();
	}

	// When initializing, we restore the data from `localStorage` into a map.
	const cache = storageClient.getItem(CACHE_KEY) || [];

	return new Map(cache);
};
